import React, { Fragment } from "react";
import { Button, Divider, Form, Icon, Image } from "semantic-ui-react";
import { TMapAuditingCheck } from "../IMapAuditing";
import Thumbnail from "../../../sg-fileupload/components/Thumbnail";


interface MapAuditingCheckDetail {
    formData?: Partial<TMapAuditingCheck>;
    onCancel?: () => void;
};

export const MapAuditingCheckDetail: React.FC<MapAuditingCheckDetail> = ({
    formData = {},
    onCancel
}) => {

    return (
        <Form className="MapAuditingCheckDetail" as="div" size="tiny">
            <Form.Field>

                {formData.status === "kunnossa" ? (
                    <Fragment>
                        < Icon name="check" color="green" /> Kunnossa
                    </Fragment>
                ) : formData.status === "korjattavaa" ? (
                    <Fragment>
                        < Icon name="times" color="red" /> Korjattavaa
                    </Fragment>
                ) : (
                    <Fragment>
                        < Icon name="question" color="grey" /> Ei tiedossa
                    </Fragment>
                )}
            </Form.Field>

            {formData.description && (
                <Form.Field>
                    <p> {formData.description} </p>
                </Form.Field>
            )}

            {(formData.images?.length || 0) > 0 && (
                <Form.Field>
                    <Image.Group className="AuditNoteItem-image-group">
                        {formData.images?.map((imageId) => (
                            <Thumbnail
                                key={imageId}
                                className="AuditNoteItem-image"
                                id={imageId}
                                thumbnailWidth={100}
                            />
                        ))}
                    </Image.Group>
                </Form.Field>
            )}

            <Divider hidden />

            <Button type="button" content="Sulje" onClick={onCancel} size="tiny" />

        </Form>
    )
};
